export const removeIndex = <T>(arr: T[], index: number): T[] => {
    return arr.filter((_, i) => i !== index);
};
